import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineExternalLink } from "react-icons/hi";
import { MdOutlineEventAvailable } from "react-icons/md";

import type { AgendaType } from "../../../../../hooks/agenda";
import { bookingTunnelUrl } from "../../agenda/agendaTypes";
import { formatPrice } from "../../agenda/agendaPayment";

const K = "customRegistration.booking.preview";

/** Where the form's preview leaves the client once registered: the booking page of the type, not a step of the form. */
export const BookingHandoverPreview: React.FC<{
  entityId: string;
  type?: AgendaType;
}> = ({ entityId, type }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="space-y-3 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
        <MdOutlineEventAvailable size={24} aria-hidden="true" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900">{t(`${K}.title`)}</h2>
      <p className="text-sm text-gray-600">
        {type ? t(`${K}.textOf`, { title: type.title }) : t(`${K}.text`)}
      </p>
      {type?.payment && (
        <p className="text-sm text-gray-600">
          {t(`${K}.paid`, {
            price: formatPrice(
              type.payment.amount,
              type.payment.currency,
              i18n.language
            ),
          })}
        </p>
      )}
      {type && (
        <a
          href={bookingTunnelUrl(entityId, type.id)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 rounded-md text-sm font-medium text-blue-600 hover:text-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        >
          {t(`${K}.open`)}
          <HiOutlineExternalLink size={14} aria-hidden="true" />
        </a>
      )}
    </div>
  );
};
